import React from 'react';

import { IconButton, Tooltip } from '@mui/material';

import { classes } from './Dropdowns/styles';

const AddButton = ({
  title,
  onClick,
  children
}: {
  title: string;
  onClick: () => void;
  children: React.ReactNode;
}) => (
  <Tooltip arrow placement="top" title={title}>
    <IconButton id="add-button" onClick={onClick} sx={classes.iconButton}>
      {children}
    </IconButton>
  </Tooltip>
);

export default AddButton;
